import React from "reactn";
import SectionThree from "./forms/SectionThree";

class MembershipPlans extends React.Component {
  render() {
    return (
      <div className="cont boxes-row mt-50px center-box">
        <SectionThree
          match={this.props.match}
          vals={this.global.myApplicationProfileInfo}
        />
      </div>
    );
  }
}

export default MembershipPlans;
